// Customer Stories copy, word for word from the legacy page (views/customers/CustomersVue.vue
// and Sections/StoriesSection.vue). The story pages themselves stay legacy (/divacs, ...).
// Covers: the legacy cover SVGs (0.6 to 1.7 MB each) rendered once to small webp files.
import divacsCover from '@/assets/img/security/story-divacs.webp';
import anthropicCover from '@/assets/img/security/story-anthropic-identity.webp';
import sharpScribeCover from '@/assets/img/security/story-sharpscribe.webp';
import divacsLogo from '@/assets/img/divac-logo.svg';
import anthropicLogo from '@/assets/img/anthropic-logo.svg';
import sharpScribeLogo from '@/assets/img/sharpscribe-logo.svg';

export const CUSTOMERS = {
  hero: {
    title: 'Customer Stories',
    lede: 'Real Success, Real Impact',
  },

  stories: {
    label: 'Customer stories',
    readMore: 'Read more',
    items: [
      {
        company: 'DIVACS',
        tag: 'B2B SAAS',
        title: 'Scaling DIVACS With DIGU',
        description:
          'With DIGU, DIVACS cut costs by 70% and onboarded top talent in less than 40 days.',
        image: divacsCover,
        logo: divacsLogo,
        route: '/divacs',
      },
      {
        company: 'Anthropic Identity',
        tag: 'B2B Services',
        title: 'Anthropic Identity Builds a Global IAM Force',
        description:
          'Anthropic Identity cut hiring time by 75% and built a global IAM team in just 2 weeks',
        image: anthropicCover,
        logo: anthropicLogo,
        route: '/anthropic-identity',
      },
      {
        company: 'SharpScribe',
        tag: 'B2B SAAS',
        title: 'SharpScribe Brings AI to the Doctor’s Office',
        description: 'SharpScribe built its AI MVP 40% faster',
        image: sharpScribeCover,
        logo: sharpScribeLogo,
        route: '/sharp-scribe',
      },
    ],
  },
};
